<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <component :is="Component" v-if="!$route.meta.keepAlive" />
  </router-view>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: transparent;
}

.flex {
  display: flex;
}
.flex-sb {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-ct {
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrap {
  flex-wrap: wrap;
}
.column {
  flex-direction: column;
}
p {
  margin: 0 !important;
}
.tip {
  flex-shrink: 0;
  color: #333333;
  text-align: center;
  font-size: 13px;
}
</style>
